import type { IPlaceholderConfig, ITemplatePageConfig } from '~/types/template'

import BackgroundImageBlock from '~/components/DynamicScreen/Blocks/BackgroundImage'
import ButtonBlock from '~/components/DynamicScreen/Blocks/Button'
import SubTitleBlock from '~/components/DynamicScreen/Blocks/SubTitle'
import TextBlock from '~/components/DynamicScreen/Blocks/Text'
import TitleBlock from '~/components/DynamicScreen/Blocks/Title'

const placeholders: IPlaceholderConfig[] = [
  {
    category: 'arguments',
    component: TitleBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'title_txt_3',
    previewProperties: {
      text: 'Marketing argument for the third slide.',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'arguments',
    component: SubTitleBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'subtitle_txt_3',
    previewProperties: {
      text: 'Subtitle arguments of the third slide onboarding. Can be on 50 characters. Be careful of your Lokalise translation',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    className: 'button-text',
    component: TextBlock,
    defaultValue: { color: '#FFFFFF', translation: 'common.continue' },
    placeholderKey: 'continue_txt_3',
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    component: ButtonBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'action_next_cta_3',
    type: ['color'],
  },
]

export const marketingPage3: ITemplatePageConfig = {
  backgroundImage: 'background_img_3',
  className: 'page-3',
  name: '3. Marketing',
  placeholders: [
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_img_3',
      type: 'asset',
    },
  ],
}

export const marketingPage3Video: ITemplatePageConfig = {
  ...marketingPage3,
  backgroundImage: 'background_video_3',
  placeholders: [
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_video_3',
      type: 'asset',
    },
  ],
}
